var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApplyPromo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5997 9.81738L9.91602 14.501",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5466 15.9438C15.3393 15.9438 15.9819 15.3012 15.9819 14.5085C15.9819 13.7158 15.3393 13.0732 14.5466 13.0732C13.7539 13.0732 13.1113 13.7158 13.1113 14.5085C13.1113 15.3012 13.7539 15.9438 14.5466 15.9438Z",
    fill: "#ACACB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86302 11.2602C10.6557 11.2602 11.2983 10.6176 11.2983 9.82493C11.2983 9.03225 10.6557 8.38965 9.86302 8.38965C9.07033 8.38965 8.42773 9.03225 8.42773 9.82493C8.42773 10.6176 9.07033 11.2602 9.86302 11.2602Z",
    fill: "#ACACB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9307 12.0301C20.9307 13.1573 19.4341 13.9736 19.0357 14.9454C18.6373 15.9172 19.0357 17.5789 18.3166 18.3466C17.5974 19.1143 15.926 18.6382 14.9153 19.056C13.9047 19.4739 13.1273 20.9996 12 20.9996C10.8727 20.9996 10.0564 19.5128 9.08466 19.056C8.11288 18.5993 6.44141 19.1046 5.68343 18.3466C4.92544 17.5887 5.38218 15.9561 4.96432 14.9454C4.54645 13.9348 3.06934 13.1573 3.06934 12.0301C3.06934 10.9028 4.56589 10.0865 4.96432 9.11473C5.36275 8.14295 4.96431 6.48121 5.68343 5.7135C6.40254 4.9458 8.074 5.42197 9.08466 5.00411C10.0953 4.58624 10.8727 3.06055 12 3.06055C13.1273 3.06055 13.9436 4.55709 14.9153 5.00411C15.8871 5.45113 17.5586 4.95551 18.3166 5.7135C19.0746 6.47149 18.6178 8.10408 19.0357 9.11473C19.4536 10.1254 20.9307 10.9125 20.9307 12.0301Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplyPromo);
export default __webpack_public_path__ + "static/media/icon_apply_promo.20d9fa0631318e217805a5a2da081486.svg";
export { ForwardRef as ReactComponent };